import React from 'react';
import { Link } from 'react-router-dom';

// Path such as: TVEC / Premises and Resources / Fire Drills.
// Every part except the last one is a link, so the user can go back to any level.
export default function TvecBreadcrumb({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`} className="flex min-w-0 items-center gap-1.5">
              {last || !item.href ? (
                <span aria-current={last ? 'page' : undefined} className="truncate font-semibold text-slate-900">{item.label}</span>
              ) : (
                <Link to={item.href} className="truncate text-sky-700 no-underline hover:underline">{item.label}</Link>
              )}
              {!last ? <span aria-hidden="true" className="text-slate-300">/</span> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
